/*!
 * jQuery claim calculator
 *
 * Calculate compensation estimate
 */
(function ($) {

  var pluginName = 'claimCalculator',
    defaults = {
      url: '/api/claim-compensation/:category',

      category: null,
      debounce: 1000,

      inputSelector:                '.js-input',
      categoryFieldSelector:        '#js-category',
      valueFieldSelector:           '#js-value',
      deductibleFieldSelector:      '#js-deductible',
      yearOfPurchaseFieldSelector:  '#js-year-of-purchase',

      loaderSelector:               '#js-loader',
      compensationSelector:         '#js-compensation',
      itemCurrentValueSelector:     '#js-item-value',

      successTextContainer:         '#js-success-text',
      errorTextContainer:           '#js-error-text'
    };

  function debounce (func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function Plugin (element, options) {
    this.element = element;
    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype = {
    init: function () {
      var $form = $(this.element);
      this.fetch = debounce(this._fetch, this.options.debounce);

      $form.on('submit', this.onFormSubmit.bind(this));
      $(this.options.inputSelector, this.element)
        .on('change', function () {
          $form.submit();
        })
        .on('keyup', debounce(this.validateElement, 250));

      this.fetch();
    },

    onFormSubmit: function (event) {
      event.preventDefault();
      this.fetch();
    },

    onSuccess: function () {
      $(this.options.successTextContainer).show();
      $(this.options.errorTextContainer).hide();
    },

    onError: function () {
      $(this.options.successTextContainer).hide();
      $(this.options.errorTextContainer).show();
    },

    update: function (data) {
      if (data.hasOwnProperty('calculatedCompensation')) {
        $(this.options.compensationSelector).text(data.calculatedCompensation + ' €');
      }
      if (data.hasOwnProperty('currentItemValue')) {
        $(this.options.itemCurrentValueSelector).text(data.currentItemValue);
      }
    },

    runQuery: function (category, value, yearOfPurchase, deductible) {
      var _this = this,
          url = this.options.url.replace(':category', category),
          params = {
            amountEstimate: encodeURIComponent(value),
            acquisitionYear: encodeURIComponent(yearOfPurchase),
            extentAmount: encodeURIComponent(deductible)
          };

      _this.showLoader();

      return $.ajax({
        type: 'get',
        url: url,
        data: params,
        success: function (data) {
          if (data.errors) {
            console.error('Claim Compensation API error');
            _this.onError();
            return;
          }
          if (!data.hasOwnProperty('calculatedCompensation')) {
            console.warn('Claim Compensation API did not yield any result');
            data.calculatedCompensation = 0;
          } else {
            data.calculatedCompensation = Math.round(data.calculatedCompensation);
          }
          if (data.hasOwnProperty('reductionPercent')) {
            data.currentItemValue = _this._calculateCurrentItemValue(value, data.reductionPercent);
          }
          _this.onSuccess();
          return _this.update(data);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('Claim Compensation API error', jqXHR, textStatus, errorThrown);
          _this.onError();
        },
        complete: function () {
          _this.hideLoader();
        }
      });
    },

    showLoader: function () {
      $(this.options.loaderSelector).show();
      $(this.options.compensationSelector).hide();
    },

    hideLoader: function () {
      $(this.options.loaderSelector).hide();
      $(this.options.compensationSelector).show();
    },

    validateElement: function (event) {
      var $element = $(event.currentTarget),
        val = $element.val(),
        pattern = $element.prop('pattern');

      if (!pattern) {
        return;
      }

      var re = new RegExp(pattern, 'gi');
      var $parent = $element.closest('.form-group');
      $parent.toggleClass('has-error', !val.match(re));
    },

    _fetch: function () {
      var value           = this._getNumericFieldValue(this.options.valueFieldSelector),
        deductible        = this._getNumericFieldValue(this.options.deductibleFieldSelector),
        yearOfPurchase    = this._getNumericFieldValue(this.options.yearOfPurchaseFieldSelector),
        category;

      // Don't calculate with zero values
      if (value <= 0 || deductible <= 0) {
        return;
      }

      if (!this.options.category) {
        category = $(this.options.categoryFieldSelector, this.element).val();
      }

      this.runQuery(category, value, yearOfPurchase, deductible);
    },

    _getNumericFieldValue: function (selector) {
      var value = parseFloat($(selector, this.element).val());
      return isNaN(value) ? 0 : value;
    },

    _calculateCurrentItemValue: function (value, percentage) {
      value = parseFloat(value);
      percentage = parseFloat(percentage) / 100;
      return Math.round(value - (value * percentage));
    }
  };

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin(this, options));
      }
    });
  };

})(jQuery, window, document);
